import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {useHistory} from "react-router-dom";
import {FormattedMessage} from "react-intl";
import {useTheme} from "@mui/material/styles";

import ArrowLeftIcon from "components/icons/ArrowLeftIcon";
import CustomButton from "components/CustomButton";

import {ProductShowContext} from "../context/ProductShowContext";

import {green500, greyishBlue100} from "assets/jss/main";

ProductTopBar.propTypes = {
    productFormDisplayed: PropTypes.bool
};

function ProductTopBar({productFormDisplayed = true}) {
    const history = useHistory();
    const theme = useTheme();

    const {
        cantEditProduct,
        attributeLoading,
        isSubmitting,
        isValid,
        submitted,
        submitForm
    } = useContext(ProductShowContext);

    return (
        <div
            style={{
                background: '#fff',
                padding: '16px',
                boxShadow: '0 2px 20px 8px rgba(23, 23, 23, 0.04)',
                borderBottom: `1px solid ${greyishBlue100}`,
                position: 'sticky',
                top: 0,
                zIndex: theme.zIndex.modal + 1,
            }}
        >
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '0px 16px',
                    // keeps the bar's height when the buttons are hidden on the variation form
                    minHeight: '40px'
                }}
            >
                <div
                    onClick={() => history.goBack()}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        fontSize: '14px',
                        fontWeight: 600,
                        cursor: 'pointer'
                    }}
                >
                    <ArrowLeftIcon size={16}/>
                    <FormattedMessage id='product.show.topBar.backToList'/>
                </div>
                {/* the variation form has its own actions at the bottom, these only drive ProductForm */}
                {productFormDisplayed && (
                    <div style={{display: 'flex', gap: '12px', alignItems: 'center'}}>
                        {submitted &&
                            <div style={{color: green500}}>
                                <FormattedMessage id='product.show.product.form.actions.submit.success'/>
                            </div>
                        }
                        {!cantEditProduct && (
                            <>
                                <CustomButton
                                    customVariant='transparent'
                                    customColor='default'
                                    noBorder
                                    disabled={isSubmitting}
                                    onClick={() => history.goBack()}
                                >
                                    <FormattedMessage id='product.show.product.form.actions.cancel'/>
                                </CustomButton>
                                <CustomButton
                                    type='submit'
                                    disabled={isSubmitting || !isValid || attributeLoading}
                                    loading={isSubmitting}
                                    onClick={submitForm}
                                >
                                    <FormattedMessage id='product.show.product.form.actions.submit'/>
                                </CustomButton>
                            </>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}

export default ProductTopBar;
